<template>
  <div class="scheduler">
    <ul class="scheduler__header">
      <li><b>{{ title }}</b></li>
      <div class="do-scroller do-scroller--hide"
           ref="topDiv"
           v-scroll="handleScrollTop">
        <ul class="scheduler__header__times">
          <li v-for="number in hoursInLocale">{{ number | LT }}</li>
        </ul>
      </div>
    </ul>
    <div class="scheduler__container">
      <div class="do-scroller__container">
        <div class="do-scroller do-scroller-max-height do-scroller--hide do-scroller__users"
             ref="leftDiv"
             v-scroll="handleScrollLeft">
          <ul class="scheduler__users">
            <li v-for="(item, idx) in itemsSorted"
                :key="item.id"
                :style="{'height': 40 * rows[item.id] + 'px'}"
                :class="{'item-is-headline': item.headline}">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="scheduler__cal">
        <div class="scheduler__cal--loading" v-if="isLoading">
          <Spinner color="blue" style="margin-top: -120px"></Spinner>
        </div>
        <div class="do-scroller__container">
          <div class="do-scroller do-scroller-max-height do-scroller--hide"
               ref="rightDiv"
               v-scroll="handleScrollRight">
            <ul class="scheduler__cal__ress">
              <ul class="scheduler__cal__ress__items">
                <SchedulerItem
                  v-for="item in itemsSorted"
                  :key="item.id"
                  :user="item"
                  @rows="setRows($event, item.id)"
                ></SchedulerItem>
              </ul>
              <ul class="scheduler__cal__timeslots">
                <li v-for="n of hoursInLocale.length * 2"></li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SchedulerItem from './DSchedulerItem'
import Spinner from '../common/Loader'
import moment from 'moment'

export default {
  components: {
    SchedulerItem,
    Spinner
  },
  directives: {
    scroll: {
      inserted: function (el, binding) {
        let f = function (evt) {
          if (binding.value(evt, el)) {
            el.removeEventListener('scroll', f)
          }
        }
        el.addEventListener('scroll', f)
      }
    }
  },
  props: {
    calendars: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Teachers'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    sortBy: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isSyncingLeftScroll: false,
      isSyncingRightScroll: false,
      isSyncingTopScroll: false,
      tags: [],
      rows: {}
    }
  },
  watch: {
    rows () {
      this.$refs.rightDiv.scrollLeft = 480
      this.$refs.topDiv.scrollLeft = 480
    }
  },
  filters: {
    round (num) {
      return Math.round(num)
    }
  },
  computed: {
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    items () {
      const calendars = JSON.parse(JSON.stringify(this.calendars))
      const evts = JSON.parse(JSON.stringify(this.events))
      const cals = calendars.map(cal => {
        let icon = ''
        switch (cal.type) {
          case 'user':
            icon = 'icon-user'
            break
          case 'room':
            icon = 'icon-location'
            break
          case 'klass':
            icon = 'icon-calendar4'
            break
          case 'other':
            icon = 'icon-clipboard2'
            break
          case 'merge':
            icon = 'icon-calendar-week'
            break
          case 'club':
            icon = 'icon-users5'
            break
        }
        this.$set(cal, 'dCalIcon', icon)
        this.$set(cal, 'userLessons', [])
        this.$set(cal, 'dayEvents', [])
        this.$set(cal, 'dayPresence', [])
        this.$set(cal, 'firstEvent', null)
        this.$set(cal, 'lastEvent', null)
        return cal
      })
      evts.forEach(event => {
        this.$set(event, 'v_calIds', [])
        this.$set(event, 'v_groups', [])
        this.$set(event, 'v_group_names', '')
        this.$set(event, 'v_users', [])
        this.$set(event, 'v_subs_for_user_ids', [])
        this.$set(event, 'v_room_ids', [])
        this.$set(event, 'v_has_teachers', false)
        this.$set(event, 'v_user_names_obj', {})
        this.$set(event, 'v_user_names', '')
        if (event.calendars) {
          event.calendars.forEach(calendar => {
            // get group
            const cal = this.allCalendarsInHash[calendar.calendar_id]
            if (cal) {
              if (event.v_calIds.indexOf(cal.id) < 0) {
                event.v_calIds.push(cal.id)
              }
              if (cal.type === 'klass') {
                event.v_groups.push(cal)
                event.v_group_names += event.v_group_names.length === 0 ? ' ' + cal.name : ', ' + cal.name
              }
              if (cal.type === 'user') {
                if (calendar.substitute) {
                  event.v_subs_for_user_ids.push(calendar.substitute)
                }
                event.v_has_teachers = true
                event.v_users.push(cal)
                const userId = this.allUsersInCalIdHash[calendar.calendar_id] ? this.allUsersInCalIdHash[calendar.calendar_id].id : null
                const userObj = {
                  userId: userId,
                  name: cal.name ? cal.name : '',
                  isSubstituted: false
                }
                event.v_user_names_obj[userId] = userObj
              }
              if (cal.type === 'room') {
                event.v_room_ids.push(cal.id)
              }
            }
          })
        }
        // find all users that has a subtitute and striketrough their names on tooltip
        event.v_subs_for_user_ids.forEach(userId => {
          if (event.v_user_names_obj[userId]) {
            event.v_user_names_obj[userId].isSubstituted = true
          }
        })
        Object.keys(event.v_user_names_obj).forEach(key => {
          const user = event.v_user_names_obj[key]
          if (user.isSubstituted) {
            event.v_user_names += '<p class="striketrough">' + user.name + '</p>'
          } else {
            event.v_user_names += '<p>' + user.name + '</p>'
          }
        })
        event.v_calIds.forEach(calId => {
          const idx = cals.findIndex(cal => cal.id === calId)
          if (idx > -1) {
            if (event.event_type === 'presence') {
              cals[idx].dayPresence.push(event)
            } else {
              cals[idx].dayEvents.push(event)
              if (!cals[idx]['firstEvent'] || moment(event.start).isBefore(cals[idx]['firstEvent'])) {
                cals[idx]['firstEvent'] = new Date(event.start).getTime()
              }
              if (!cals[idx]['lastEvent'] || moment(event.end).isAfter(cals[idx]['lastEvent'])) {
                cals[idx]['lastEvent'] = new Date(event.end).getTime()
              }
            }
          }
        })
      })
      return cals
    },
    itemsSorted () {
      if (!this.sortBy) {
        const userLocale = 'en'
        return this.items.sort((a, b) => {
          return a.name.localeCompare(b.name, userLocale, {
            numeric: true,
            sensitivity: 'base'
          })
        })
      }
      if (this.sortBy === 'firstEvent') {
        return this.items.sort((itemA, itemB) => {
          const a = itemA['firstEvent']
          const b = itemB['firstEvent']
          return (a === null) - (b === null) || +(a > b) || -(a < b)
        })
      }
      if (this.sortBy === 'lastEvent') {
        return this.items.sort((itemA, itemB) => {
          const a = itemA['lastEvent']
          const b = itemB['lastEvent']
          return (a === null) - (b === null) || -(a > b) || +(a < b)
        })
      }
      return this.items
    },
    hoursInLocale () {
      let hours = []
      for (let i = 0; i < 24; i++) {
        hours.push(moment().set({hour: i, minutes: 0, seconds: 0}))
      }
      return hours
    }
  },
  methods: {
    setRows (obj, userid) {
      this.$set(this.rows, userid, obj.rows)
    },
    handleScrollRight (evt, el) {
      if (!this.isSyncingRightScroll) {
        this.isSyncingLeftScroll = true
        this.isSyncingTopScroll = true
        this.$refs.leftDiv.scrollTop = el.scrollTop
        this.$refs.topDiv.scrollLeft = el.scrollLeft
      }
      this.isSyncingRightScroll = false
    },
    handleScrollLeft (evt, el) {
      if (!this.isSyncingLeftScroll) {
        this.isSyncingRightScroll = true
        this.$refs.rightDiv.scrollTop = el.scrollTop
      }
      this.isSyncingLeftScroll = false
    },
    handleScrollTop (evt, el) {
      if (!this.isSyncingTopScroll) {
        this.isSyncingRightScroll = true
        this.$refs.rightDiv.scrollLeft = el.scrollLeft
      }
      this.isSyncingTopScroll = false
    }
  }
}
</script>


<style scoped>
@import '../../assets/css/variables.css';

.scheduler {
  position: relative;
  height: 100%;
  width: 100%;
}

.scheduler ul {
  margin: 0 !important;
}

.scheduler__header {
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  display: flex;
  overflow: hidden;
  background: #fff;
}

.scheduler__header > li:first-child {
  padding: 4px 0 4px 8px;
}

.scheduler__header > li:first-child,
.scheduler__users {
  min-width: 220px;
  max-width: 220px;
  border-right: 1px solid #ccc;
}

.scheduler__header__times {
  display: flex;
  flex: 1;
  max-width: 1920px;
}

.scheduler__header__times > li {
  display: flex;
  flex: 1;
  min-width: 80px;
  border: 0 solid #ebeff3;
  border-left-width: 1px;
  text-align: left;
  padding: 4px;
}

.scheduler__users > li {
  border: 0 solid #ebeff3;
  border-bottom-width: 1px;
  display: flex;
  height: 100%;
  align-items: center;
  padding: 4px 0 4px 8px;
}

.scheduler__users__headline {
  display: flex;
  align-items: center;
  height: 100%;
  user-select: none;
}

.scheduler__users__user {
  display: flex;
  height: 100%;
  width: 220px;
  justify-content: space-between;
}

.scheduler__container {
  display: flex;
  background: #fff;
}

.scheduler__cal {
  position: relative;
  flex: 1;
  display: flex;
  overflow: hidden;
}

.scheduler__cal--loading {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(245, 245, 245, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.scheduler__cal__ress {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: calc(48px * 40px);
}

.scheduler__cal__ress > .scheduler__cal__ress__items > li {
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid rgba(217, 217, 217, .7);
  border-width: 0 0 1px;
  z-index: 1;
}

.scheduler__users > li:nth-child(even),
.scheduler__cal__ress > .scheduler__cal__ress__items > li:nth-child(even) {
  background-color: rgba(237, 240, 245, 0.4);
}

.scheduler__cal__timeslots {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.scheduler__cal__timeslots > li {
  position: relative;
  min-width: 40px;
  flex: 1;
  border: 0 solid #ebeff3;
  border-left-width: 1px;
}

.scheduler__cal__timeslots > li:nth-child(2n) {
  border-left-style: dotted;
}

.do-scroller__container {
  overflow: hidden;
}

.do-scroller {
  width: 100%;
  overflow: auto;
}

.do-scroller-max-height {
  overflow: auto;
  height: 100%;
  max-height: 100vh;
  margin: 0px;
}

.do-scroller__users.do-scroller-max-height {
  overflow: auto scroll;
  margin: 0px -15px -15px 0px !important;
  min-width: 235px;
  max-width: 235px;
  padding-bottom: 15px;
}

.do-scroller.do-scroller--hide {
  margin: 0px 0px -15px;
}

.item-is-headline {
  background-color: #3e4450 !important;
  color: #fff !important;
  font-weight: 700;
  position: relative;
}

.scheduler_user__headline {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  line-height: 40px;
  padding-left: 10px;
}

.sub-popover {
  border-radius: 4px;
  position: absolute;
  top: 0;
  bottom: 15px;
  right: 15px;
  z-index: 500;
  width: 275px;
  min-height: 200px;
  font-size: 14px;
  background-color: white;
  color: black;
  border-radius: 4px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .19), 0 6px 6px rgba(0, 0, 0, .23);
}

.close-cross {
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 10px;
  color: #ffffff;
}

.zoomIn-enter-active {
  animation: zoomIn .25s;
}

.zoomIn-leave-active {
  animation: zoomIn .25s reverse;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }

  50% {
    opacity: 1;
  }
}

.flip-list-move {
  transition: transform .75s;
}

.flip-list-move-enter, .flip-list-move-leave-to
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateX(-30px);
}

.flip-list-move-leave-active {
  position: absolute;
}

</style>



// WEBPACK FOOTER //
// DScheduler.vue?345b3680